export const THIN = "200";
export const LIGHT = "300";
export const REGULAR = "400";
export const MEDIUM = "500";
export const SEMIBOLD = "600";
export const BOLD = "700";
